export const DAY_LIST: readonly string[] = ['일', '월', '화', '수', '목', '금', '토'];
